import { SocraticDialogueFragment } from "@/generated/graphql";

export type CompletedDialogue = {
  id: string;
  attemptNumber: number;
  mediaUrl: string;
  durationSeconds: number;
};

export function toCompletedDialogues(
  dialogues: SocraticDialogueFragment[]
): CompletedDialogue[] {
  return dialogues
    .flatMap((d): CompletedDialogue[] => {
      const response = d.turns[0]?.response;
      if (response?.mediaUrl == null) {
        return [];
      }
      return [
        {
          id: d.id,
          attemptNumber: d.attemptNumber,
          mediaUrl: response.mediaUrl,
          durationSeconds: response.durationSeconds ?? 0,
        },
      ];
    })
    .sort((a, b) => a.attemptNumber - b.attemptNumber);
}
